import { Component, OnInit, forwardRef, Input, SimpleChanges, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';

import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';

export class ShopFilterItem {
    id: any;
    label: string;
    selected: boolean = false;
    constructor(id: any, label: string){
        this.id = id;
        this.label = label;
   }
}

@Component({
    selector: 'app-shop-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    imports: [
        IonIcon, TranslatePipe
    ]
})
export class ShopFilterComponent  implements OnInit {
      
    @Input({alias : 'items', required : true}) items: Array<ShopFilterItem>;
    @Input({alias : 'title', required : true}) title: string;
    @Input({alias : 'multiple', required : false}) multiple: boolean = true;
    @Output() onChangeFilter = new EventEmitter<Array<ShopFilterItem>>();
     
    @ViewChild('shopFilter') shopFilter: ElementRef;
     
    isOpened: boolean = false;
    labelValue: string = '';
    itemsCopy: Array<ShopFilterItem> = [];
     
    constructor(             
        private renderer: Renderer2
    ) { 
        this.renderer.listen('window', 'click',(e: any)=> { 
            if (!this.shopFilter.nativeElement.contains(e.target) 
                && !e.target.classList.contains('shop_filter_icon')) {
                this.isOpened = false;
            } 
        }); 
    }

    ngOnInit() {
        this.init();
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        if(changes['items']){
            this.init();
        }
    }
    
    init(){
        this.cloneItems();
        this.getLabelsOptionsSelected();
    }
    
    cloneItems(){
        let itemsCopy: Array<ShopFilterItem> = [];
        this.items.forEach(o => {
            itemsCopy.push(Object.assign({}, o));
        });
        this.itemsCopy = itemsCopy;
    }
    
    openDropdown(){
        this.isOpened = !this.isOpened;
    }
    
    displayAll(emitUpdate: boolean = true){
        this.itemsCopy.forEach(o => {
            o.selected = false;
        });        
        this.getLabelsOptionsSelected();  
        this.isOpened = false;   
        if(emitUpdate){     
            this.onChangeFilter.emit([]);
        }
    }
    
    toggleItem(item: ShopFilterItem){
        item.selected = !item.selected;
        if(!this.multiple){
            let itemSelected = this.itemsCopy.find(i => i.id !== item.id && i.selected);
            if(itemSelected){
                itemSelected.selected = false;
            }
        }
        this.getLabelsOptionsSelected();
        this.onChangeFilter.emit(this.itemsCopy.filter(o => o.selected));
        if(!this.multiple){
            this.isOpened = false;  
        }
    }
    
    getLabelsOptionsSelected(){
        let labels = this.itemsCopy.filter(o => o.selected).map(o => o.label);
        this.labelValue = (labels.length > 0 ? labels.join(', ') : this.title);
    }
}
